!(function () {
  'use strict';
  customElements.get('login-form') ||
    customElements.define(
      'login-form',
      class extends HTMLElement {
        constructor() {
          super(),
            (this.showButton = this.querySelector('[data-show-reset]')),
            (this.hideButton = this.querySelector('[data-hide-reset]')),
            (this.recover = this.querySelector('[data-recover-password]')),
            (this.recoverSuccess = this.querySelector('[data-recover-success]')),
            (this.login = this.querySelector('[data-login-form]')),
            this.init();
        }
        init() {
          '#recover' == window.location.hash || this.recoverSuccess
            ? this.showRecoverPasswordForm()
            : this.hideRecoverPasswordForm(),
            this.showButton.addEventListener('click', (e) => {
              e.preventDefault(), this.showRecoverPasswordForm();
            }),
            this.hideButton.addEventListener('click', (e) => {
              e.preventDefault(), this.hideRecoverPasswordForm();
            });
          const e = this.login.querySelector('form');
          e &&
            (e.removeEventListener('submit', this.handleLoginSubmit),
            e.addEventListener('submit', (e) => {
              console.log('Submit event triggered!'),
                e.preventDefault(),
                e.stopImmediatePropagation(),
                console.log('preventDefault called!'),
                this.handleLoginSubmit(e);
            }));
        }
        async handleLoginSubmit(e) {
          const t = e.target,
            s = new FormData(t),
            o = s.get('customer[email]') || s.get('email');
          if (o)
            try {
              const e = await fetch(
                `https://apps.gloross.com/PraevaScience/CheckB2BTag?email=${encodeURIComponent(o)}`,
                {method: 'POST', headers: {'Content-Type': 'application/json'}}
              );
              const redirectPath = window.location.pathname.includes('/en-bg/')
                ? '/en-bg/pages/b2b-dashboard'
                : '/pages/b2b-dashboard';
              (await e.json()).result
                ? ((t.querySelector('[name="return_url"]').value = redirectPath), t.submit())
                : t.submit();
            } catch (e) {
              console.error('Error checking B2B status:', e);
            }
        }
        showRecoverPasswordForm() {
          return (
            this.login.classList.add('is-hidden'),
            this.recover.classList.remove('is-hidden'),
            (window.location.hash = '#recover'),
            !1
          );
        }
        hideRecoverPasswordForm() {
          return (
            this.recover.classList.add('is-hidden'),
            this.login.classList.remove('is-hidden'),
            (window.location.hash = ''),
            !1
          );
        }
      }
    );
})();
